import { FaWind } from "react-icons/fa6";
import CardLayout from "../common/CardLayout";
import TitleCard from "../common/TitleCard";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import Table from "../common/table";
import { useEffect, useState } from "react";
import getCurrentUnidadeId from "../../funcs/getCurrentUnidadeId";
import { format } from "date-fns";
import { orderBy } from "../../funcs";
import apiLinhaProducao from "../../services/apis/apiLinhaProducao";

export default function LinhaProducao() {

    const unidadeId = getCurrentUnidadeId();
    const [leituras, setLeituras] = useState([]);

    useEffect(() => {
        (async () => {
            const res = await apiLinhaProducao.getByUnidadeId(unidadeId);
            const linhaProducao = res.data;
            const leiturasLinhaProducao = linhaProducao.map((linhaProducao) => ({...linhaProducao.leiturasLinhaProducao[0], nome: linhaProducao.nome, linhaProducaoId: linhaProducao.id}));
                        
            orderBy(leiturasLinhaProducao, "linhaProducaoId");
            setLeituras(leiturasLinhaProducao);
        })();
    },[unidadeId]);


    return <CardLayout>
    <Accordion
        type="single"
        defaultValue="item-1"
        collapsible="true"
    >
        <AccordionItem value="item-1">
            <div className="font-semibold">
                <AccordionTrigger>
                    <TitleCard>
                        Linha Produção
                        <p className="text-lg lg:text-4xl px-2"></p>
                    </TitleCard>
                </AccordionTrigger>
            </div>
            <AccordionContent>
                <div className="w-full">
                        <Table.Root>
                            <Table.Head>
                                {/* <Table.Header>
                                    <p className="font-bold">
                                        . . .
                                    </p>
                                </Table.Header> */}
                                <Table.Header>
                                    Linha Produção Id
                                </Table.Header>
                                <Table.Header>
                                    Nome
                                </Table.Header>
                                <Table.Header>
                                    Data Hora
                                </Table.Header>
                                <Table.Header>
                                    Quantidade
                                </Table.Header>
                            </Table.Head>
                            <Table.Body>
                                {leituras?.map(
                                    (
                                        leitura
                                    ) => (
                                        <Table.Row
                                            key={
                                                leitura.id
                                            }
                                        >
                                            <Table.Data>
                                                {
                                                    leitura.linhaProducaoId
                                                }
                                            </Table.Data>
                                            <Table.Data>
                                                {
                                                    leitura.nome
                                                }
                                            </Table.Data>
                                            <Table.Data>
                                                {
                                                    leitura?.dataHora ? format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss") === "01/01/0001 00:00:00" ? "Sem leitura" : format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss") : "Sem leitura"
                                                }
                                            </Table.Data>
                                            <Table.Data>
                                                {
                                                    leitura?.quantidade ? leitura.quantidade : "Sem leitura"
                                                }
                                            </Table.Data>
                                        </Table.Row>
                                    )
                                )}
                            </Table.Body>
                        </Table.Root>
                </div>
            </AccordionContent>
        </AccordionItem>
    </Accordion>
</CardLayout>
}